import styled from 'styled-components'

const LanguageSwitcherUi = styled.div`
  margin-left: 10px;
  display: flex;
  align-items: center;
`

export default LanguageSwitcherUi
